export const SB_CLOSE_ALL = "SB_CLOSE_ALL";
export const SB_OPEN_ANY = "SB_OPEN_ANY";
